import{useCallback as e}from"react";
/**
 *
 * @deprecated
 * 削除予定です。onClickを直接利用してください
 */var r=()=>({handleClickByDevice:e((e=>({onClick:r=>{r.preventDefault(),e(r)}})),[])});export{r as useHandleClickByDevice};
